import React from 'react'
import { SchoolsHealthCentersLegend2 } from '../legend/SchoolsHealthCentersLegend2'
import { SchoolsHealthCentersLegend3 } from '../legend/SchoolsHealthCentersLegend3'

export const schoolsHealthCentersLegend = {
  'Health facilities': <SchoolsHealthCentersLegend2 />,
  'Schools': <SchoolsHealthCentersLegend3 />,
}
